"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carat = void 0;
var AXSIcon_1 = __importDefault(require("../../elements/AXSIcon"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.Carat = styled_components_1.default(AXSIcon_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  margin: ", ";\n  pointer-events: none;\n  z-index: 9;\n"], ["\n  display: ", ";\n  margin: ", ";\n  pointer-events: none;\n  z-index: 9;\n"])), function (_a) {
    var active = _a.active;
    return !active ? 'inline-block' : 'none';
}, function (_a) {
    var margin = _a.margin;
    return margin ? margin : '6px 0 0 -16px';
});
var templateObject_1;
//# sourceMappingURL=Carat.js.map